import type {
  ArtifactPanelViewEntry,
  PushViewOptions,
} from './artifact-panel-context';

export function pushViewEntry(
  stack: readonly ArtifactPanelViewEntry[],
  entry: ArtifactPanelViewEntry,
  options?: PushViewOptions
): ArtifactPanelViewEntry[] {
  if (options?.replaceTop === true && stack.length > 0) {
    return [...stack.slice(0, -1), entry];
  }
  return [...stack, entry];
}

export function popViewEntry(
  stack: readonly ArtifactPanelViewEntry[]
): ArtifactPanelViewEntry[] {
  if (stack.length === 0) {
    return [];
  }
  return stack.slice(0, -1);
}

/**
 * The deepest entry `match` claims, plus every entry above it.
 *
 * All of an artifact's drill-ins share one stack, including those raised from
 * inside a view the artifact doesn't render itself (an artifact link's body).
 * A host that matched only the top entry would stop recognising its own view
 * the moment something pushed on top of it and fall back to rendering the bare
 * artifact — so hosts claim the deepest entry they own and hand `nested` to it,
 * letting the view render (or ignore) whatever was stacked on it.
 */
export function resolveDeepestView<T>(
  stack: readonly ArtifactPanelViewEntry[],
  match: (payload: unknown) => T | null
): { value: T; nested: readonly ArtifactPanelViewEntry[] } | null {
  for (let i = stack.length - 1; i >= 0; i--) {
    const matched = match(stack[i]?.payload);
    if (matched !== null) {
      return { value: matched, nested: stack.slice(i + 1) };
    }
  }
  return null;
}
